import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { AnimeDetailPage } from '@/pages/AnimeDetailPage';
import { BrowsePage } from '@/pages/BrowsePage';
import { GenresPage } from '@/pages/GenresPage';
import { HomePage } from '@/pages/HomePage';
import { LibraryPage } from '@/pages/LibraryPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SearchPage } from '@/pages/SearchPage';
import { WatchPage } from '@/pages/WatchPage';

export const router = createBrowserRouter([
	{
		path: '/',
		element: <AppLayout />,
		children: [
			{ index: true, element: <HomePage /> },
			{ path: 'duyet', element: <BrowsePage /> },
			{ path: 'tim-kiem', element: <SearchPage /> },
			{ path: 'the-loai', element: <GenresPage /> },
			{ path: 'phim/:slug', element: <AnimeDetailPage /> },
			// Không kèm tập thì WatchPage tự chuyển hướng về tập đầu tiên.
			{ path: 'xem/:slug', element: <WatchPage /> },
			{ path: 'xem/:slug/:episodeSlug', element: <WatchPage /> },
			{ path: 'thu-vien', element: <LibraryPage /> },
			{ path: 'thu-vien/:tab', element: <LibraryPage /> },
			{ path: '*', element: <NotFoundPage /> },
		],
	},
]);
